import * as React from 'react';
import errorReporter from '@app/errorReporter';
import { VirtualTourJsonType, BasicContact } from '@bb/domain/dist/types';

import { getVirtualTourForDash } from '../api';

interface Coop extends BasicContact {
  id?: string;
}
interface UseGetVirtualToursForDashProps {
  coop?: Coop;
  dashboardId?: string;
  retsId?: string;
  listingId: string;
  setShouldGetTours: React.Dispatch<React.SetStateAction<boolean>>;
  shouldGetTours: boolean;
  setCreatedRoom: React.Dispatch<React.SetStateAction<string>>;
  createdRoom: string;
  updateState: any;
  setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>;
}
interface FinalTours extends VirtualTourJsonType {
  key: string;
}

const useGetVirtualToursForDash = ({
  coop,
  dashboardId,
  retsId,
  listingId,
  setShouldGetTours,
  shouldGetTours,
  setCreatedRoom,
  createdRoom,
  updateState,
  setSelectedRowKeys,
}: UseGetVirtualToursForDashProps): {
  tours: FinalTours[];
  isLoading: boolean;
} => {
  const [tours, setTours] = React.useState<FinalTours[]>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getTours = async () => {
      try {
        setIsLoading(true);
        const res = await getVirtualTourForDash({
          dashboardId,
          retsId,
          listingId,
          coopId: coop?.id || coop?.uid,
        });
        setTours(res);
        if (createdRoom) {
          const createdTour = res.find(
            (tour: any) => tour.room === createdRoom,
          );

          updateState((draft: any) => {
            draft.selectedTour = { ...createdTour, invitees: draft.invitees };
          });
          setSelectedRowKeys([createdTour.key]);
          setCreatedRoom(null);
        }
      } catch (err) {
        errorReporter.error('Error getting virtual tours: ', err);
      } finally {
        setShouldGetTours(false);
        setIsLoading(false);
      }
    };

    if (shouldGetTours && (dashboardId || retsId || coop?.id || coop?.uid)) {
      getTours();
    }
    setShouldGetTours(false);
  }, [shouldGetTours]);

  React.useEffect(() => {
    if (coop?.id || coop?.uid) {
      setShouldGetTours(true);
    }
  }, [coop?.id, coop?.uid]);

  return { tours, isLoading };
};

export default useGetVirtualToursForDash;
